import { default as React, ReactElement } from 'react'
import { uniqueId } from 'lodash'
import ReactSelect, { GroupBase, Props as SelectProps } from 'react-select'
import CreatableSelect from 'react-select/creatable'

interface IOption<T> {
  label: string
  value: T
}

export interface IOwnProps<T, IsMulti extends boolean = false>
  extends SelectProps<IOption<T>, IsMulti, GroupBase<IOption<T>>> {
  id?: string
  label?: string
  error?: string | boolean
  creatable?: boolean
}

const Select = <T = string, IsMulti extends boolean = false>({
  id = uniqueId(),
  label,
  error,
  creatable = false,
  ...props
}: IOwnProps<T, IsMulti>): ReactElement => {
  return (
    <div className="select">
      <label htmlFor={id} className="select_label">
        {label}
      </label>
      {!creatable && <ReactSelect classNamePrefix="select" {...props} />}
      {creatable && <CreatableSelect classNamePrefix="select" {...props} />}
      {error && <div className="select_error">{error}</div>}
    </div>
  )
}

export default Select
